// redux/reducers/authUserReducer.js
const initialState = {
  usersList: null,
  userLoading: false,
  error: null,
};

const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_USERS_LIST":
      return {
        ...state,
        usersList: action.payload,
        userLoading: false,
      };
    case "GET_USERS_LIST_LOADING":
      return {
        ...state,
        userLoading: true,
      };
    case "GET_USERS_LIST_ERROR":
      return {
        ...state,
        error: action.payload,
        userLoading: false,
      };
    default:
      return state;
  }
};

export default userListReducer;
